import React, { useEffect } from 'react';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { Tooltip } from '@material-ui/core';
import { createRoot } from 'react-dom/client';

const controlContainer = document.createElement('div');
const id = 'hide-routed-orders-control-container';
controlContainer.setAttribute('id', id);
const containerRoot = createRoot(controlContainer);

const HideRoutedOrdersControlContent = ({ isHidden, callbacks }) => {
    return (
        <Tooltip title={isHidden ? 'Show routed orders' : 'Hide routed orders'} placement="top">
            <div
                css={css`
                    margin: 10px;
                    width: 40px;
                    height: 40px;
                    background-color: ${isHidden ? '#FAFAFA' : colors.greens.primary};
                    color: ${isHidden ? colors.greens.primary : colors.white};
                    border-radius: 2px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                `}
                onClick={callbacks.onToggle}
            >
                {isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </div>
        </Tooltip>
    );
};

export const HideRoutedOrdersControl = ({ mapRef, hideRoutedOrders, callbacks }) => {
    useEffect(() => {
        if (mapRef?.current) {
            const controls = mapRef.current.controls[window.google.maps.ControlPosition.RIGHT_TOP];

            controls.push(controlContainer);

            return () => {
                const idx = controls.indexOf((el) => el.id === id);
                if (idx >= 0) {
                    controls.removeAt(idx);
                }
            };
        }
    }, [mapRef?.current]);

    useEffect(() => {
        if (mapRef?.current) {
            containerRoot.render(<HideRoutedOrdersControlContent isHidden={hideRoutedOrders} callbacks={callbacks} />);
        }
    }, [hideRoutedOrders, mapRef?.current]);

    return null;
};
